module.exports = __webpack_public_path__ + "images/album_640.95e90f3a2ec9c70e2b0f6b7082be38f0.png";